import axios from 'axios';

import { env } from 'env';
import {
  EventAssetType,
  IEventAssets,
} from '@providers/EventProvider/interfaces';

export default class EventsService {
  static getAssets({
    eventId,
    type,
    limit = -1,
  }: {
    eventId: string;
    type: EventAssetType;
    limit?: number;
  }): Promise<IEventAssets> {
    return axios
      .get(
        `${env.REACT_APP_API_URL}api/v2/events/${eventId}/assets?limit=${limit}&type=${type}`,
      )
      .then((res: any) => res.data);
  }
}
